import React, { useState } from 'react';
import axios from 'axios';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { requestEmailChange } from '../../utils/getData/User';
import { validateHandler, validateEmail } from '../../utils/validate/Validate';

export const EmailChangeButton: React.FC = () => {
  const [show, setShow] = useState(false);
  const [email, setEmail] = useState("");
  const [emailError, setEmailError] = useState("この項目は入力必須です");
  const [postError, setPostError] = useState("");
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(false);

  const handleEmailChange = validateHandler(setEmail, setEmailError, validateEmail);

  // 開くたびに前回の入力・送信結果を持ち越さないよう初期化する
  const handleShow = () => {
    setEmail("");
    setEmailError("この項目は入力必須です");
    setPostError("");
    setSent(false);
    setShow(true);
  };
  const handleClose = () => {
    if (sending) {
      return;
    }
    setShow(false);
  };

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    // モーダルはポータルで描画されるが、React のイベントはコンポーネントの親子関係で伝播する。
    // 止めないと外側の登録情報フォームの送信まで動いてしまう
    event.stopPropagation();

    if (emailError !== "" || sending) {
      // 通常はここを通らないので何もしない
      return;
    }

    setSending(true);
    setPostError("");
    try {
      await requestEmailChange(email);
      setSent(true);
    } catch (error) {
      if (axios.isAxiosError(error) && error.response && error.response.status === 400) {
        const data = error.response.data as { email?: string[] };
        setPostError(data && data.email && data.email.length > 0 ? data.email[0] : "入力内容をご確認ください。");
      } else {
        setPostError("送信に失敗しました。時間を空けてもう一度お試しください。");
      }
    } finally {
      setSending(false);
    }
  };

  return (
    <>
      <Button variant="secondary" onClick={handleShow} className="px-3 py-1">
        メールアドレスを変更
      </Button>

      <Modal show={show} onHide={handleClose} backdrop={sending ? "static" : true}>
        <Modal.Header closeButton={!sending}>
          <Modal.Title>メールアドレスの変更</Modal.Title>
        </Modal.Header>
        {sent ? (
          <Modal.Body>
            <p className="fs-description mb-3">
              {email} 宛に確認メールを送信しました。
            </p>
            <p className="fs-description mb-3">
              メールに記載されたURLにアクセスすると、メールアドレスの変更が完了します。<br />
              URLの有効期限は24時間です。
            </p>
            <p className="fs-caption mb-3 text-danger">
              ※変更が完了すると自動的にログアウトされます。お手数ですが、新しいメールアドレスで再度ログインしてください。
            </p>
            <p className="fs-caption">
              ※メールが届かない場合は、迷惑メールフォルダをご確認のうえ、メールアドレスに誤りがないか今一度ご確認ください。
            </p>
            <div className='d-flex justify-content-end'>
              <Button variant="gray-600" className="text-white" onClick={handleClose}>閉じる</Button>
            </div>
          </Modal.Body>
        ) : (
          <form onSubmit={handleSubmit}>
            <Modal.Body>
              <p className="title">新しいメールアドレス</p>
              <input
                className="form-control"
                type="text"
                name="email"
                placeholder="example@gmail.com"
                value={email}
                onChange={handleEmailChange}
                autoFocus />
              <div className="text-danger">{emailError}</div>
              <p className="fs-caption mt-1">
                ※入力したメールアドレス宛に確認メールを送信します。メールに記載されたURLにアクセスするまで変更は完了しません。
              </p>
              <p className="fs-caption mt-1 text-danger">
                ※メールアドレスの変更が完了すると自動的にログアウトされます。新しいメールアドレスで再度ログインしてください。
              </p>
              {postError !== "" && (
                <p className="text-danger text-center">{postError}</p>
              )}
              <div className='d-flex justify-content-end mt-3'>
                <Button variant="blue" className="text-white me-3" type="submit" disabled={emailError !== "" || sending}>
                  {sending ? "送信中..." : "確認メールを送信する"}
                </Button>
                <Button variant="gray-600" className="text-white" onClick={handleClose} disabled={sending}>閉じる</Button>
              </div>
            </Modal.Body>
          </form>
        )}
      </Modal>
    </>
  );
};

export default EmailChangeButton;
